export default {
  name: 'HomePage'
};